import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  zoomInButton: {
    id: 'EtdNDX',
    defaultMessage: 'Zoom in',
    description: 'Aria label for the zoom in button in the HTML editor preview',
  },
  zoomOutButton: {
    id: 'jRNmqY',
    defaultMessage: 'Zoom out',
    description: 'Aria label for the zoom out button in the HTML editor preview',
  },
  refreshButton: {
    id: 'icZQm6',
    defaultMessage: 'Refresh preview',
    description: 'Aria label for the refresh button in the HTML editor preview',
  },
});
